import PropTypes from 'prop-types';
import React from 'react';
import { WeezHeader, Button, Card, Message, Form } from '@weezevent/nacre';

import { useHistory } from 'react-router-dom';

import { useTranslation } from 'react-i18next';
import Tag from '../../models/tag';

export default function TagsForm({ match, organization, tagId }) {
    const { t } = useTranslation();
    const [value, setValue] = React.useState('');
    const history = useHistory();

    const organizationId = organization.id;
    let tag = null;
    let isLoading = null;

    if (tagId) {
        [tag, isLoading] = Tag.useApiModel({
            organizationId,
            id: tagId
        });
    }

    React.useEffect(() => {
        if (tag) {
            setValue(tag.label);
        }
    }, [tagId, tag]);

    const handleInput = React.useCallback((_, { value: newValue }) => {
        setValue(newValue);
    }, []);

    const handleSubmit = React.useCallback(() => {
        const newTag = new Tag();
        if (tagId) {
            newTag.id = tagId;
        }
        newTag['label'] = value;

        newTag.save({ organizationId }).then(() => {
            history.push(`/ticket/O${organization.id}/tags`);
        });
    }, [value, tagId, history]);

    return (
        <>
            <WeezHeader
                title={t(['ticket.tags.form.header'])}
                rightComponent={[<Button primary key="primary" label={t([`ticket.common.action.${tagId ? 'edit' : 'save'}`])} onClick={handleSubmit} disabled={isLoading} />]}
                backLink={{ onClick: () => history.push(`/ticket/O${organization.id}/tags`) }}
            />
            <Form>
                <Card.FormManager useSteps={false}>
                    <Card.FormStep
                        title={t(['ticket.tags.form.title-card'])}
                        rightComponent={
                            <Message type={'tips'} title={t(['ticket.common.tips'])} mini>
                                {t(['ticket.tags.form.tips'])}
                            </Message>
                        }
                    >
                        <Form.Field>
                            <Form.Label label={t(['ticket.tags.form.label'])} />
                            <Form.Input name="firstname" placeholder={t(['ticket.tags.form.placeholder'])} onChange={handleInput} value={value} />
                        </Form.Field>
                    </Card.FormStep>
                </Card.FormManager>
            </Form>
        </>
    );
}

TagsForm.propTypes = {
    match: PropTypes.object.isRequired,
    organization: PropTypes.object.isRequired,
    tagId: PropTypes.number
};

TagsForm.defaultProps = {
    tagId: null
};
